module.exports = __webpack_public_path__ + "img/40_25.27d5d808.png";